export enum HrocJtbdRole {
  ReliabilityEngineer = 'Reliability Engineer',
  ProcessEngineer = 'Process Engineer',
  QualityEngineer = 'Quality Engineer',
  SystemsEngineer = 'System Engineer',
  OptimizationSpecialist = 'Optimization Specialist',
  OutagePlanner = 'Major Outage Lead'
}
